<template> 
    <div v-show="loaded" class="iframe-container" :style="[hasContainerStyle ? setContainerStyle : '']">
        <div id="iframe" class="iframe" :style="[hasIframeStyle ? setIframeStyle : '']"></div>
    </div>
</template>

<script>

import * as pbi from 'powerbi-client';
import MetodosGlobais from '@/utils/MetodosGlobais'

export default {
  name: 'iframePowerBI',
  components: {
  },
  props:{
    fonte: {
      type: Object,
      default: () => ({})
    },

    allowfullscreen: null
  },
  data() {
    return {
      loaded: false,
      // tempo mínimo faltante para considerar o refresh do token
      MINUTES_BEFORE_EXPIRATION: 10,
      // tempo de refresh de 60 segundos
      INTERVAL_TIME: 60000,
      // tempo faltante para expirar o token
      tokenExpiration: 0,
      hasIframeStyle: false,
      iframeStyle: "",
      hasContainerStyle: false,
      containerStyle: ""
    }
  },
  watch: {
    fonte: function (newFonte, oldFonte) {
        // Carregamento
        if(typeof newFonte.id !== 'undefined' && typeof oldFonte.id === 'undefined'){
            if(MetodosGlobais.isObject(this.fonte.iframeEmbeddingConfig.estiloIframe) && 
              Object.keys(this.fonte.iframeEmbeddingConfig.estiloIframe).length) {
                this.iframeStyle = this.fonte.iframeEmbeddingConfig.estiloIframe
                this.hasIframeStyle = true
            } else {
              if(this.fonte.iframeEmbeddingConfig.minWidth) {
                this.iframeStyle = {"min-width": this.fonte.iframeEmbeddingConfig.minWidth}
                this.hasIframeStyle = true
              }
              if(this.fonte.iframeEmbeddingConfig.minHeight) {
                if(this.iframeStyle === ''){
                    this.iframeStyle = {"min-height": this.fonte.iframeEmbeddingConfig.minHeight} 
                }
                else {
                  this.iframeStyle["min-height"] = this.fonte.iframeEmbeddingConfig.minHeight
                }
                this.hasIframeStyle = true
              }
            }
            if(MetodosGlobais.isObject(this.fonte.iframeEmbeddingConfig.estiloContainer) && 
              Object.keys(this.fonte.iframeEmbeddingConfig.estiloContainer).length) {
                this.containerStyle = this.fonte.iframeEmbeddingConfig.estiloContainer
                this.hasContainerStyle = true
            }
            else if(this.fonte.iframeEmbeddingConfig.height) {
                this.containerStyle = {"height": this.fonte.iframeEmbeddingConfig.height}
                this.hasContainerStyle = true
            }
            this.atualizarDashboard()
        } else {
            this.updateToken(this.fonte.nome);
        }
    }
  },
  created () {
    this.$store.commit('loading/startLoading');
  },
  mounted () {

  },
  computed: {
    setContainerStyle() {
      return this.containerStyle
    },
    setIframeStyle() {
      return this.iframeStyle
    }
  },
  methods: {
	atualizarDashboard() {
        this.loaded = true
        this.tokenExpiration = this.fonte.iframeEmbeddingConfig.tokenExpiry
        var permissions = pbi.models.Permissions.All
        var config = {
            type: 'report',
            tokenType:  pbi.models.TokenType.Embed,
            accessToken: this.fonte.iframeEmbeddingConfig.embedToken,
            embedUrl: this.fonte.iframeEmbeddingConfig.embedUrl,
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
                panes: {
                    bookmarks: {
                        visible: false
                    },
                    fields: {
                        expanded: false
                    },
                    filters: {
                        expanded: false,
                        visible: false
                    },
                    pageNavigation: {
                        visible: false
                    },
                    selection: {
                        visible: false
                    },
                    syncSlicers: {
                        visible: false
                    },
                    visualizations: {
                        expanded: false
                    }
                }
            }
        };

        let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
        var reportContainer = document.getElementById('iframe');
        var report = powerbi.embed(reportContainer, config);

        report.on("error", function () {
            this.report.off("error");
        });

        report.on("loaded", function () {
          this.$store.commit('loading/endLoading')
        }.bind(this))

        this.adicionarEventos(this.fonte.nome)

    },
    adicionarEventos(nome) {
        // Add a listener to make sure token is updated after tab was inactive
        this.checkTokenAndUpdate.bind(this)
        document.addEventListener("visibilitychange", (nome) => {
            // Check the access token when the tab is visible
            if (!document.hidden) {
                this.checkTokenAndUpdate(nome)
            }
        });

        setInterval(() => this.checkTokenAndUpdate(this.fonte.nome), this.INTERVAL_TIME);
    },
    checkTokenAndUpdate(nomeIframe) {

        // Get the current time
        const currentTime = Date.now();
        const expiration = Date.parse(this.tokenExpiration);

        // Time until token expiration in milliseconds
        const timeUntilExpiration = expiration - currentTime;
        const timeToUpdate = this.MINUTES_BEFORE_EXPIRATION * 60 * 1000;

        // Update the token if it is about to expired
        if (timeUntilExpiration <= timeToUpdate)
        {
            this.$emit('token-refresh')
        }
    },
    updateToken(nomeIframe) {
        // Update the new token expiration time
        this.tokenExpiration = this.fonte.iframeEmbeddingConfig.tokenExpiry

        // Get a reference to the embedded report HTML element
        let embedContainer = document.getElementById('iframe');

        // Get a reference to the embedded report.
        let report = powerbi.get(embedContainer);
        // Set the new access token
        report.setAccessToken(this.fonte.iframeEmbeddingConfig.embedToken);
    }
  },
  
}
</script>

<style scoped>

.iframe-container {
  overflow: hidden;
  position: relative;
}
@media (min-width: 858px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 767px) and (max-width: 857px) {
  .iframe-container {
    height: calc(100vh - 190px);
  }
}

@media (min-width: 614px) and (max-width: 766px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 364px) and (max-width: 613px) {
  .iframe-container {
    height: calc(100vh - 200px);
  }
}
@media (max-width: 363px) {
  .iframe-container {
    height: calc(100vh - 262px);
  }
}
 
.iframe-container .iframe {
   border: 0;
   height: 100%;
   left: 0;
   position: relative;
   top: 0;
   width: 100%;
}

</style>



